<template>
  <b-standard-card
    :title="translations.title[lang]"
    :submit-text="translations.save"
    height="auto"
    class="mt-5"
    :loading="loading"
    :error-message="errorMessage"
    :disabled="!getPermission(`settings.point_titles.${saveAction}`)"
    @submit="saveTierSettings()"
  >
    <h4 class="text--primary" v-text="translations.question[lang]"></h4>
    <v-radio-group class="mt-3 pt-0" hide-details v-model="serverSettings.enabled">
      <v-radio color="secondary" :value="true">
        <template v-slot:label>
          <h4 class="subtitle-2 text--primary" v-text="translations.yes[lang]"></h4>
        </template>
      </v-radio>
      <v-radio color="secondary" :value="false">
        <template v-slot:label>
          <h4 class="subtitle-2 text--primary" v-text="translations.no[lang]"></h4>
        </template>
      </v-radio>
    </v-radio-group>
    <div
      class="transitioned"
      :style="{ 'max-height': (serverSettings.enabled && '650px') || '0px' }"
    >
      <div v-if="serverSettings.enabled" class="d-flex flex-column ml-1 mt-4 bordered">
        <div class="mb-2 pb-2" style="border-bottom: 1px dashed rgba(0, 0, 0, 0.1)">
          <h4
            class="text--primary"
            v-text="translations[`modeDesrciption_${storeMode}`][lang]"
          ></h4>
          <v-radio-group class="mt-3 pt-0" hide-details v-model="serverSettings.package_mode">
            <v-radio color="secondary" value="points">
              <template v-slot:label>
                <h4
                  class="subtitle-2 text--primary"
                  v-text="translations[`available_${storeMode}`][lang]"
                ></h4>
              </template>
            </v-radio>
            <v-radio color="secondary" value="amount">
              <template v-slot:label>
                <h4 class="subtitle-2 text--primary" v-text="translations.totalAmount[lang]"></h4>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
        <div>
          <h4 class="text--primary" v-text="translations.expireDescription[lang]"></h4>

          <v-radio-group class="mt-3 pt-0" hide-details v-model="serverSettings.tier_mode_id">
            <v-radio color="secondary" :value="2">
              <template v-slot:label>
                <h4
                  class="subtitle-2 text--primary"
                  v-html="translations[`yesExpire_${storeMode}`][lang]"
                ></h4>
              </template>
            </v-radio>
            <v-radio color="secondary" :value="1">
              <template v-slot:label>
                <h4 class="subtitle-2 text--primary" v-html="translations.noExpire[lang]"></h4>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
      </div>
    </div>
    <v-dialog v-model="saveAlert" :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'">
      <PointTierAlertDialog
        @close="closeTierAlertDialog"
        @submit="updateTierSettings()"
        :alert-text="this.translations.confirmSaveMsg[this.lang]"
      />
    </v-dialog>
  </b-standard-card>
</template>

<script>
import translations from '@/utils/translations/loyaltyPanel/businessProfile/tiers';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import PointTierAlertDialog from '@/components/loyaltyPanel/pointTitles/PointTierAlertDialog';

export default {
  name: 'Tiers',
  components: { PointTierAlertDialog },
  mixins: [translations],
  data() {
    return {
      saveAlert: false,
      serverSettings: {},
    };
  },

  computed: {
    ...mapState('loyaltyPanel', ['tiers_settings']),

    lang() {
      return this.$route.params.lang;
    },
    loading() {
      return this.$store.state.loyaltyPanel.businessProfile.loading.tiers;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    errorMessage() {
      return this.$store.state.loyaltyPanel.businessProfile.errorMessage.tiers;
    },
    resetSuccess() {
      return this.$store.state.loyaltyPanel.businessProfile.resetSuccess.tiers;
    },
    saveAction() {
      if (!this.serverSettings.enabled) {
        return 'create';
      } else if (this.serverSettings.enabled && !this.tiers_settings.enabled) {
        return 'delete';
      } else {
        return 'update';
      }
    },

    // tiersEnabled : {
    //   get(){
    //     return this.$store.state.loyaltyPanel.businessProfile.userPointValue;
    //   },
    //   set(val){
    //     this.setTiers(val);
    //   }
    // }
  },

  methods: {
    // ...mapMutations("loyaltyPanel/businessProfile", ["setTiers"]),
    ...mapActions('loyaltyPanel/businessProfile', ['updateTiersSettings']),
    ...mapActions(['getPermission']),

    async saveTierSettings() {
      if (this.tiers_settings.enabled && !this.serverSettings.enabled) {
        this.saveAlert = true;
      } else {
        await this.startUpdateTierSettings();
      }
    },
    closeTierAlertDialog() {
      this.saveAlert = false;
    },
    async startUpdateTierSettings() {
      this.saveAlert = false;
      await this.updateTiersSettings(this.serverSettings);
    },
  },
  watch: {
    tiers_settings: {
      immediate: true,
      handler(val) {
        this.serverSettings = { ...this.tiers_settings };
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.transitioned {
  transition: all 0.5s ease-out;
  overflow: hidden;
}
.bordered {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  padding: 7px;
}
</style>
